module.exports = __webpack_public_path__ + "img/咖啡豆@2x(1).d9d51998.png";